import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from 'react';
import { useRive } from '@rive-app/react-canvas';
import { Island } from '../../../../../components/island/Island';
import './screenshot.scss';
var ScreenshotContainer = function ScreenshotContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "screenshot-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot"
  }, children)));
};
export var RiveEmbed = function RiveEmbed(_ref2) {
  var riveUrl = _ref2.riveUrl;
  var _useRive = useRive({
      src: riveUrl
    }),
    RiveComponent = _useRive.RiveComponent,
    rive = _useRive.rive;
  useEffect(function () {
    if (!rive) return;
    // play the first state machine by default - `.play()` can be ambiguous if multiple animations are present
    var _rive$stateMachineNam = _slicedToArray(rive.stateMachineNames, 1),
      firstState = _rive$stateMachineNam[0];
    rive.play(firstState);
  }, [rive]);
  return /*#__PURE__*/React.createElement(RiveComponent, {
    className: "screenshot-rive"
  });
};
export var Screenshot = function Screenshot(_ref3) {
  var image = _ref3.image,
    riveUrl = _ref3.riveUrl;
  if (riveUrl) {
    return /*#__PURE__*/React.createElement(ScreenshotContainer, null, /*#__PURE__*/React.createElement(Island, {
      Component: RiveEmbed,
      riveUrl: riveUrl
    }));
  }
  return /*#__PURE__*/React.createElement(ScreenshotContainer, null, image && /*#__PURE__*/React.createElement("img", {
    src: image,
    className: "screenshot-image",
    alt: "Screenshot of Milanote"
  }));
};